import React from "react";
import { Grid, TextField } from "@mui/material";

export default function ProjectIdField({ value, classes, onChange }) {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val !== "" && !/^[0-9\b]+$/.test(val)) return;
    onChange({ project_id: val });
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={2}
        sx={{
          fontWeight: "bold",
          paddingLeft: "10px",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        案件ID
      </Grid>
      <Grid
        item
        xs={8}
        sm={2}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <TextField
          className={classes?.inputArea}
          variant="standard"
          fullWidth
          name="projectID"
          id="projectID"
          value={value || ""}
          InputProps={{
            style: { fontSize: 16 },
          }}
          onChange={handleChange}
        />
      </Grid>
    </>
  );
}